import * as Scrivito from "scrivito";

const OpusPublicationWidget = Scrivito.provideWidgetClass(
  "OpusPublicationWidget",
  {
    attributes: {
      mode: ["enum", { values: ["id", "author"] }],
      opusId: "string",
      authorName: "string",
    },
    extractTextAttributes: ["opusId", "authorName"],
  }
);

export default OpusPublicationWidget;
